<div class="admission">
  <span class="admission__cap">
    @if (capped()) {
      <span class="admission__count">{{ capCount() }}</span>
      <span class="admission__label">{{ 'Running at once' | translate }}</span>
    } @else {
      <span class="admission__count" aria-hidden="true">∞</span>
      <span class="admission__label">{{ 'Unlimited concurrent assignments' | translate }}</span>
    }
  </span>
  <span class="admission__tags">
    <i class="pi pi-tag" aria-hidden="true"></i>
    <span class="admission__label">{{ 'Worker tags' | translate }}</span>
    @if (visibleTags().length === 0) {
      <span class="process-tag process-tag--any">{{ 'Any worker' | translate }}</span>
    } @else {
      @for (tag of visibleTags(); track tag) {
        <span class="process-tag">{{ tag }}</span>
      }
    }
  </span>
</div>
